var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 26.1665C2 24.3352 2.74628 22.579 4.07466 21.2841C5.40304 19.9892 7.20472 19.2617 9.08333 19.2617H23.25C25.1286 19.2617 26.9303 19.9892 28.2587 21.2841C29.5871 22.579 30.3333 24.3352 30.3333 26.1665C30.3333 27.0821 29.9602 27.9602 29.296 28.6077C28.6318 29.2551 27.731 29.6189 26.7917 29.6189H5.54167C4.60236 29.6189 3.70152 29.2551 3.03733 28.6077C2.37314 27.9602 2 27.0821 2 26.1665Z",
    stroke: "#F8F8F8",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1665 12.3571C19.1005 12.3571 21.479 10.0386 21.479 7.17857C21.479 4.31853 19.1005 2 16.1665 2C13.2325 2 10.854 4.31853 10.854 7.17857C10.854 10.0386 13.2325 12.3571 16.1665 12.3571Z",
    stroke: "#F8F8F8",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profileIcon.c38106f6723befb28c4db52dbf91657d.svg";
export { ForwardRef as ReactComponent };